import reduxThunk from 'redux-thunk';
import { routerMiddleware } from 'react-router-redux';

import history from '../AppHistory';
import {
  getExamDataMiddleware,
  updateAppealDataMiddleware,
  approveExamMiddleware,
  setExamsAvailabilityMiddleware,
  changeExamMiddleware,
} from './middlewares/examDataMiddleware';
import {
  checkUserSnilsMiddleware,
  getUserDataMiddleware,
  changeUserDataMiddleware,
} from './middlewares/userDataMiddleware';
import { setChatIntervalMiddleware } from './middlewares/timeSlotChatMiddleware';
import { giaMiddleware } from './middlewares/giaMiddleware';
import notCorrectExamMiddleware from '../store/middlewares/notCorrectExamMiddleware';
import stepPersonMiddleware from '../store/middlewares/stepPersonMiddleware';
import saveDraftMiddleware from '../store/middlewares/saveDraftMiddleware';
import loadDraftMiddleware from '../store/middlewares/loadDraftMiddleware';
import deleteDraftMiddleware from '../store/middlewares/deleteDraftMiddleware';
import loadServiceFavoriteStatusMiddleware from '../store/middlewares/loadServiceFavoriteStatusMiddleware';
import changeServiceFavoriteStatusMiddleware from '../store/middlewares/changeServiceFavoriteStatusMiddleware';
import changeActRecordMiddleware from './middlewares/changeActRecordMiddleware';
import changeApplicantTypeMiddleware from './middlewares/changeApplicantTypeMiddleware';

const middlewares = [
  ...stepPersonMiddleware,
  ...notCorrectExamMiddleware,
  giaMiddleware,
  getUserDataMiddleware,
  changeUserDataMiddleware,
  checkUserSnilsMiddleware,
  getExamDataMiddleware,
  changeApplicantTypeMiddleware,
  updateAppealDataMiddleware,
  approveExamMiddleware,
  changeExamMiddleware,
  setExamsAvailabilityMiddleware,
  setChatIntervalMiddleware,
  saveDraftMiddleware,
  loadDraftMiddleware,
  deleteDraftMiddleware,
  routerMiddleware(history),
  loadServiceFavoriteStatusMiddleware,
  changeServiceFavoriteStatusMiddleware,
  changeActRecordMiddleware,
  reduxThunk,
];

export default middlewares;
